// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5fe70450","453":"97299591","667":"53465edb"}[chunkId] + ".chunk.js";
};